import React, { useState, useContext } from 'react'
import { Divider, Modal, Tag, Slider, InputNumber, message } from 'antd'

import { OffersContext, isExpired } from './context'
import 'antd/dist/antd.css'
import { ErpClientContext } from '../../services/erp'

export function PromoTag({ record }) {
  const ctx = useContext(OffersContext)
  const erp = useContext(ErpClientContext)
  const [modal, setModal] = useState(false)
  const [discount, setDiscount] = useState(record.descuento_oferta)

  const updateValue = async () => {
    const res = await erp.fetch(`/offers/${record.id}/`, {
      method: 'PATCH',
      body: JSON.stringify({ descuento_oferta: discount }),
    })
    if (res.status === 200) {
      message.success(`Discount updated to ${discount}`)
      ctx.onUpdate()
    } else {
      message.error(`Failed updating discount ${res.body}`)
    }
    setModal(false)
  }

  if (record.id_tipo === 'p') {
    return (
      <Tag color="#87d068">
        {record.uni_compra}+{record.uni_promo}
      </Tag>
    )
  }

  if (record.id_tipo === 'm') {
    return <Tag color="#87d068">Mix 6</Tag>
  }

  if (record.id_tipo === 'e') {
    return (
      <Tag color="#87d068">
        x{record.cantidad_precio_especial} -{record.descuento_especial * 100}(%)
      </Tag>
    )
  }

  return (
    <>
      <Modal
        visible={modal}
        onCancel={() => setModal(false)}
        onOk={(ev) => updateValue()}
      >
        <h2>Edit Discount</h2>
        <Slider
          min={0}
          max={1}
          onChange={(v) => setDiscount(v)}
          value={typeof discount === 'number' ? discount : 0}
          step={0.05}
        />
        <Divider />
        <InputNumber
          min={0}
          max={1}
          style={{ margin: '0 16px' }}
          value={discount}
          onChange={(v) => setDiscount(v)}
        />
      </Modal>
      <Tag
        color="#87d068"
        onClick={() => {
          if (isExpired(record)) {
            message.error(`Expired records are not updatable`)
            return
          }
          setModal(true)
        }}
      >
        -{record.descuento_oferta * 100}%
      </Tag>
    </>
  )
}
